import {
  assignRemoteId,
  updateFirstVersionIds,
} from 'serviceWorker/db/documentations/documentations';

export type AddRemoteIdToDocumentation = (localId: number, remoteId: string) => Promise<number>;

export type AddRemoteVersionIdToDocumentation = (
    localId: number,
    versionId: string,
    remoteAwsVersionId: string
  ) => Promise<number>;

export const addRemoteIdToDocumentation: AddRemoteIdToDocumentation =
  function _addRemoteIdToDocumentation(localId, remoteId) {
    return assignRemoteId(localId, remoteId);
  };

export const addRemoteVersionIdToDocumentation: AddRemoteVersionIdToDocumentation =
  function _addRemoteVersionIdToDocumentation(
    localId,
    versionId,
    remoteAwsVersionId
  ) {
    return updateFirstVersionIds(localId, versionId, remoteAwsVersionId);
  };
